type IconProps = React.SVGProps<SVGSVGElement>;

const Copy: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.1248 11.125H14.8748V1.125H4.87483V4.875M1.12476 4.87509H11.1248V14.8751H1.12476V4.87509Z"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Copy;
